import React, { Component } from "react";

import SectionList from "./SectionList.js";
import ArticleItem from "./ArticleItem.js";

class ArticleList extends SectionList {
  constructor(props) {
    super(props);

    this.initial_path = this.state.items[0].meta.permalink;
  }

  loadMorePath = () => {
    let url = this.initial_path;
    url = `${url}/load_more?page=${this.state.items.length}`;
    if (this.state.initial_qs) {
      url += "&" + this.state.initial_qs;
    }
    return url;
  };

  componentDidMount() {
    /* window.instgrm.Embeds.process(); */
    /* debugger; */
    let initial_qs = window.location.search.split("?")[1];
    this.setState({ initial_qs: initial_qs });
  }

  // renderItem = item => {
  //   return <div>Test</div>;
  // };

  // renderItem = item => {
  //   return (
  //       <div
  //     className={this.props.itemClassName}
  //     key={item.id}
  //     dangerouslySetInnerHTML={{ __html: item.html }}
  //       />
  //   );
  // };

  renderItem = item => {
    return (
      <ArticleItem
        className={this.props.itemClassName}
        key={item.id}
        item={item}
        initial_qs={this.state.initial_qs}
      />
    );
  };
}

export default ArticleList;
